// Le fichier source s'appelle `ui-theme` (pas `app.config.ui`) car Tailwind/Nuxt
// excluent les fichiers nommés `app.config.*` du scan source → toutes les classes
// Tailwind des overrides y seraient absentes du CSS final.
import { sharedAppConfigUi } from "@carnet/ui/nuxt/ui-theme";

export default defineAppConfig({
  ui: sharedAppConfigUi,
});
